module.exports = __webpack_public_path__ + "static/hero-e1e5991b917f77d8e132b521ff036b41.jpg";